#import "../fragments/peep-related-lead-stat-fragment.graphql"

fragment PeepRelatedLeadStatsFragment on LeadStats {
    all {
        ...PeepRelatedLeadStatFragment
    }
    openAndPending {
        ...PeepRelatedLeadStatFragment
    }
}
